import { toLower } from "lodash";

import dayjs from "dayjs";

// used for FB advanced matching
import {
  getGokickUUID,
  getUserID,
  getVisitBirthday,
  getVisitEmail,
  getVisitFirstName,
  getVisitGender,
  getVisitLastName,
  getVisitPhone,
  getVisitUSState,
} from "../../visits/utils/visitCookies";

import posthog from "posthog-js";

import { builder } from "@builder.io/react";

export const AMPLITUDE_API_KEY_TESTING = "c5262200717040ec2ece24a5719f20be";
export const AMPLITUDE_APIKEY_PRODUCTION = "63dd68466f7f14c5cf6e16f5ed4b78aa";

export const BUILDER_IO_API_KEY = "8ed23e53ad6147b784de3ef824f5e5f4";

const EVENT_TYPE_DOCTOR_VISIT_START = "Doctor Visit Start";
const EVENT_TYPE_DOCTOR_VISIT_COMPLETE = "Doctor Visit Complete";
const EVENT_TYPE_DOCTOR_VISIT_CHECKOUT = "Doctor Visit Checkout";
const EVENT_TYPE_DOCTOR_VISIT_PRESCRIPTION_WRITTEN =
  "Doctor Visit Prescription Written";
const EVENT_TYPE_DOCTOR_VISIT_REFERRAL_PRIMARY_CARE =
  "Doctor Visit Referral Primary Care";
const EVENT_TYPE_REFILL_CHECKOUT = "Refill Checkout";

const EVENT_TYPE_PATIENT_CREATED = "Complete Registration";
const EVENT_TYPE_PATIENT_PORTAL_LOGIN = "Patient Portal Login";
const EVENT_TYPE_PATIENT_MESSAGE_SENT = "Patient Message Sent";

export const FB_PIXEL_ID = "1883879761863029";
export const FB_EVENT_PURCHASE = "Purchase";

export const GTM_EVENT_SIGNUP = "Signup";
export const GTM_EVENT_PURCHASE = "Purchase";

export const GA_CATEGORY_KITS = "Kits";
export const GA_CATEGORY_CONSULTATION = "Consultation";

export const GA_CATEGORY_SIGNUP = "Signup";

export function trackPatientPortalLogin() {
  // track(EVENT_TYPE_PATIENT_PORTAL_LOGIN);
}

export function trackRefillCheckout(userID) {
  // track(EVENT_TYPE_REFILL_CHECKOUT);
}

export function trackPatientMessageSent(userID) {
  // track(EVENT_TYPE_PATIENT_MESSAGE_SENT);
}

//--------------------------------------
// GTM & GA
export function gtmDataLayerPush(obj) {
  if (window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
  }
}

export function gtmTrackGAEvent(
  eventCategory,
  eventAction,
  eventLabel,
  eventValue
) {
  gtmTrackCustomGTMGAEvent(
    "GAEvent",
    eventCategory,
    eventAction,
    eventLabel,
    eventValue
  );
}

export function gtmTrackCustomGTMGAEvent(
  eventName,
  eventCategory,
  eventAction,
  eventLabel,
  eventValue
) {
  gtmDataLayerPush({
    event: eventName,
    eventCategory: eventCategory,
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: eventValue,
  });
}

export function trackPurchaseGTM(obj) {
  console.log("trackPurchaseGTM: ", obj);
  gtmDataLayerPush(obj);
}

// -------------------------------
// FB

export function fbqReInit() {
  var bday = "";

  // parse visit birthday and format defensively.
  if (getVisitBirthday() != "") {
    const bdayJS = dayjs(getVisitBirthday());
    if (bdayJS.isValid()) {
      bday = bdayJS.format("YYYYMMDD");
    }
  }

  var phone = getVisitPhone();
  if (phone != "") {
    phone = "1" + phone; // facebook requires country code
  }

  if (window.fbq) {
    var initData = {
      em: toLower(getVisitEmail()).trim(),
      fn: toLower(getVisitFirstName()).trim(),
      ln: toLower(getVisitLastName()).trim(),
      ph: phone, // facebook requires country code
      ge: toLower(getVisitGender()).trim(),
      st: toLower(getVisitUSState()).trim(),
      db: bday, // facebook requires digits only with birth year, month, then day - 19910526 for May 26, 1991.
      country: "us",
      external_id: getUserID(),
    };
    console.log("initData: ", initData);
    window.fbq("init", FB_PIXEL_ID, initData);
  } else {
    console.log("fbq not available...");
  }
}

export function fbPixel(eventName, objProps) {
  if (window.fbq) {
    window.fbq("track", eventName, objProps);
  }
}

export function trackPurchaseFB(objProps) {
  fbPixel(FB_EVENT_PURCHASE, objProps);
}
// -------------------------------
// Kick Events

export function trackSignup(usState, consultationType) {
  gtmTrackCustomGTMGAEvent(
    GTM_EVENT_SIGNUP,
    GA_CATEGORY_SIGNUP,
    `${GTM_EVENT_SIGNUP} - ${usState}`,
    consultationType,
    1
  );

  //   fbPixel("CompleteRegistration", {
  //     value: 0,
  //     currency: "USD",
  //   });
}

export function trackKitStart(service) {
  gtmTrackGAEvent(GA_CATEGORY_KITS, "Kit Checkout Started", service, 1);
}

// ================= Klaviyo Events ====================================
export function identifyKlaviyoPatientSignUp(email, consultationType) {
  var _learnq = _learnq || [];
  _learnq.push([
    "identify",
    {
      $email: email,
      signup_consultation_type: consultationType,
    },
  ]);
}

export function identifyKlaviyoPatientLogin(email) {
  var _learnq = _learnq || [];
  _learnq.push([
    "identify",
    {
      $email: email,
    },
  ]);
}

// ----------------- End Klaviyo Events --------------------------------
// ================= Customer.io Events ====================================
export function identifyCustomerIOPatientSignUp(email, consultationType) {
  const userID = getUserID();
  // Customer.io's identify() expects a SINGLE object whose first property is the
  // identifier (id / cio_id / email). Passing the id positionally —
  // identify(getUserID(), {...}) — makes the SDK evaluate `e.id` on the id
  // string and throw "undefined is not an object (evaluating 'e.id')" whenever
  // the userID cookie is absent (e.g. Safari ITP), which aborts the caller's
  // post-signup navigation. Guard on having an identifier, then pass one object
  // — mirroring identifyCustomerIOPatientLogin below.
  if (window._cio && (userID || email)) {
    window._cio.identify({
      id: userID, // Use either cio_id, id, or email.
      email: email,
      gokick_uuid: getGokickUUID(),
      signup_consultation_type: consultationType,
    });
  }
}

export function identifyCustomerIOPatientLogin(email) {
  window._cio &&
    window._cio.identify({
      email: email, // Use either cio_id, id, or email.
    });
}

// ----------------- End Customer.io Events --------------------------------

// ================= Posthog Events ====================================

// The /me/rate/<token> rating link is a bearer credential (see
// docs/patient-ratings.md). The patient-portal bundle keeps PostHog off on
// that page entirely; this is belt-and-braces for any other bundle that
// captures a URL or referrer still carrying the token.
const RATING_TOKEN_URL_RE = /\/me\/rate\/[A-Za-z0-9_-]{20,}.*$/;
const RATING_URL_PROPERTY_KEYS = [
  "$current_url",
  "$pathname",
  "$referrer",
  "$initial_referrer",
];
// posthog nests the person-property copies under $set / $set_once.
const RATING_URL_NESTED_KEYS = ["$set", "$set_once"];
const RATING_URL_NESTED_PROPERTY_KEYS = RATING_URL_PROPERTY_KEYS.concat([
  "$initial_current_url",
  "$initial_pathname",
]);

export function redactRatingTokenURL(value) {
  if (typeof value !== "string" || !RATING_TOKEN_URL_RE.test(value)) {
    return value;
  }
  return value.replace(RATING_TOKEN_URL_RE, "/me/rate/[redacted]");
}

function redactRatingTokenKeys(obj, keys) {
  if (!obj || typeof obj !== "object") {
    return obj;
  }
  let out = obj;
  keys.forEach((key) => {
    const redacted = redactRatingTokenURL(obj[key]);
    if (redacted !== obj[key]) {
      if (out === obj) {
        out = { ...obj };
      }
      out[key] = redacted;
    }
  });
  return out;
}

// posthog `sanitize_properties` hook: rewrites the URL-ish properties that
// match /me/rate/<token> to end in /me/rate/[redacted]; every other property
// is passed through untouched.
export function sanitizeRatingTokenProperties(properties) {
  let out = redactRatingTokenKeys(properties, RATING_URL_PROPERTY_KEYS);
  if (!out || typeof out !== "object") {
    return out;
  }
  RATING_URL_NESTED_KEYS.forEach((nestedKey) => {
    const nested = out[nestedKey];
    const redacted = redactRatingTokenKeys(
      nested,
      RATING_URL_NESTED_PROPERTY_KEYS,
    );
    if (redacted !== nested) {
      if (out === properties) {
        out = { ...properties };
      }
      out[nestedKey] = redacted;
    }
  });
  return out;
}

export function posthogInit() {
  posthog.init("phc_OLS0YTqBd4MT0Ajo0mRyrdmCOOf041jFmARHtBYI2yi", {
    api_host: "https://disco.gokick.com",
    ui_host: "https://us.i.posthog.com",
    person_profiles: "always",
    sanitize_properties: sanitizeRatingTokenProperties,
    enable_recording_console_log: true,
    disable_session_recording: false,
    capture_console_logs: true,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: { password: true },
      recordHeaders: true,
      recordBody: true,
      maskCapturedNetworkRequestFn: (data) => {
        // Redact sensitive endpoints (login, signup, registration, the
        // realtime intake answer check — its body carries the raw symptom
        // text — and the rating page: its URL carries the invitation token
        // and its API body the patient's comment)
        const url = data.url || "";
        if (
          url.includes("login") ||
          url.includes("signup") ||
          url.includes("password") ||
          url.includes("assess-answer") ||
          url.includes("rating-invitations") ||
          url.includes("/me/rate")
        ) {
          // Return null to skip capturing this request entirely
          return null;
        }

        // Capture all other requests with full body
        return data;
      },
    },
    enable_heatmaps: true,
    // Flag requests are billed per call to PostHog's /flags endpoint, and the SDK
    // calls it on every init unless told not to. We need flags on exactly one screen
    // (the payment step), so fetching them on ~1M pageviews a month would put us over
    // the 1M free tier for nothing. Experiments call reloadFeatureFlags() when they
    // actually need a variant -- see shared/experiments.
    advanced_disable_feature_flags_on_first_load: true,
  });
}

export function posthogStartSessionRecording() {
  posthog.startSessionRecording(true);
}

export const identifyUser = (userID, ...args) => {
  const id = userID || getUserID();
  posthog.identify(id, ...args);
};

// Subscription pause/resume events (patient portal). These flows reload the page as soon as the
// mutation resolves, so the event must go out before navigation. The installed posthog-js
// (1.363.3) does NOT honor options.transport on capture — what actually gets the event through
// is that passing ANY truthy options object makes capture send immediately instead of joining
// the batching queue, and the library's fetch uses keepalive, which lets the in-flight request
// survive the page unload. Keep the options object: it is what triggers the instant send.
function posthogCaptureBeforeNavigation(eventName, properties = {}) {
  posthog.capture(eventName, properties, { transport: "sendBeacon" });
}

export function trackSubscriptionPauseModalOpened(properties) {
  posthogCaptureBeforeNavigation(
    "Subscription Pause Modal Opened",
    properties,
  );
}

export function trackSubscriptionPaused(properties) {
  posthogCaptureBeforeNavigation("Subscription Paused", properties);
}

export function trackSubscriptionPauseFailed(properties) {
  posthogCaptureBeforeNavigation("Subscription Pause Failed", properties);
}

// A scheduled pause undone before taking effect — no charge, original billing date kept.
export function trackSubscriptionPauseCanceled(properties) {
  posthogCaptureBeforeNavigation("Subscription Pause Canceled", properties);
}

// A functionally paused subscription resumed early — charged today to restart.
export function trackSubscriptionResumed(properties) {
  posthogCaptureBeforeNavigation("Subscription Resumed", properties);
}

// Subscription cancel-flow events (patient portal). The flow's single entry point is the card's
// "⋮" menu; the pause-instead offer inside the flow reuses the pause events above with
// source "cancel_flow", so a pause taken from the cancel flow shows up as Subscription Paused.
export function trackSubscriptionCancelModalOpened(properties) {
  posthogCaptureBeforeNavigation(
    "Subscription Cancel Modal Opened",
    properties,
  );
}

// An end-of-period cancellation was scheduled (the sub stays active until cancel_at).
export function trackSubscriptionCanceled(properties) {
  posthogCaptureBeforeNavigation("Subscription Canceled", properties);
}

export function trackSubscriptionCancelFailed(properties) {
  posthogCaptureBeforeNavigation("Subscription Cancel Failed", properties);
}

// A scheduled cancellation undone ("Keep my subscription") before it took effect.
export function trackSubscriptionCancelUndone(properties) {
  posthogCaptureBeforeNavigation("Subscription Cancel Undone", properties);
}

// ----------------- End Posthog Events --------------------------------
// ================= Builder.io Events ====================================

export function builderIOInit() {
  builder.init(BUILDER_IO_API_KEY);
}

export function trackBuilderConversion(value) {
  builder.trackConversion(value);
}

// ----------------- End Builder.io Events --------------------------------
// ================= VWO Events ====================================

export function trackVWOConversion(value) {
  window.VWO = window.VWO || [];
  window.VWO.push(["track.revenueConversion", value]);
}

// ----------------- End VWO Events --------------------------------
